import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Form,
    Container,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from "reactstrap";
import Select from "react-select";

import useFetch from "Hooks/useFetch";
import useUserContext from "Hooks/useUserContext";

interface IOption {
    value: string;
    label: string;
}

export default function LoginAs() {
    const [formData, setFormData] = useState<IOption>({
        value: "",
        label: "Search for a user...",
    });
    const [users, setUsers] = useState<IUser[]>([]);

    const [, onSetUserContext] = useUserContext();

    const navigate = useNavigate();
    const { get, post } = useFetch();
    const ignore = useRef(false);

    /** onChange handler for react-select Select input */
    const handleFormChange = (newValue: IOption) => {
        setFormData(newValue);
    };

    async function submitFormData() {
        const url = `/api/admin/login_as`;
        const body = {
            user_id: formData.value,
        };

        const response = await post(url, body);

        const data = await response.json();
        console.log("Login as another user response: ", data);

        if (response.ok) {
            onSetUserContext({
                userId: data.user_id,
                username: data.username,
                isCalanceAdmin: data.is_calance_admin
                    ? data.is_calance_admin
                    : "0",
                procoreLoginCompanies: data.procore_login_companies,
            });

            navigate("/login_company");
        } else {
            console.error("Error logging in as another user.");
        }
    }

    // Get users on page load
    useEffect(() => {
        ignore.current = false;

        getUsers();

        async function getUsers() {
            const response = await get(`api/admin/login_as`);

            let data: Response | IUser[];
            try {
                data = await response.json();
                console.log(data);
            } catch (e) {
                data = response;
            }

            if (response.ok && !ignore.current) {
                setUsers(data as IUser[]);
            }
        }

        return () => {
            ignore.current = true;
        };
    }, [get]);

    const goToLastPage = () => {
        navigate(-1);
    };

    const userOptionsForSelectInput = users.map((u) => {
        const label = u.name ? `${u.user_id} - ${u.name}` : u.user_id;

        return {
            value: u.user_id,
            label,
        };
    });

    return (
        <Container>
            <Modal isOpen={true}>
                <ModalHeader toggle={goToLastPage}>
                    Sign in as Another User
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <Select
                            classNamePrefix="rs"
                            value={formData}
                            options={userOptionsForSelectInput}
                            onChange={(e) => handleFormChange(e as IOption)}
                        />
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        size="lg"
                        onClick={submitFormData}
                        disabled={formData.value === ""}
                    >
                        Sign In
                    </Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
}
